module.exports = __webpack_public_path__ + "img/6.6ef201ef.png";